import React from "react";
import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import Home from "../home/home";
import AboutUs from "../listings/aboutus";
import ListingGrid from "../listings/listinggrid";
import ListingDetails from "../listings/listingDetails";
import Admin from "../admin/admin";
import AddCar from "../admin/addCar";
import CarRequest from "../car-request/CarRequest";
import TermsConditions from "../pages/termsConditions";
import PrivacyPolicy from "../pages/privacyPolicy";
import CookiesPolicy from "../pages/cookiesPolicy";
import GdprPolicy from "../pages/gdprPolicy";
import Contact from "../pages/contact";

const routes = all_routes;

export const publicRoutes = [
  {
    path: routes.home,
    name: "home",
    element: <Home />,
    route: Route,
  },
  {
    path: routes.aboutus,
    name: "aboutus",
    element: <AboutUs />,
    route: Route,
  },
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: "*",
    name: "NotFound",
    element: <Navigate to="/index" />,
    route: Route,
  },
  {
    path: routes.listinggrid,
    name: "listing-grid",
    element: <ListingGrid />,
    route: Route,
  },
  {
    path: `${routes.listingdetails}/:id`,
    name: "listing-details",
    element: <ListingDetails />,
    route: Route,
  },
  {
    path: routes.carRequest,
    name: "car-request",
    element: <CarRequest />,
    route: Route,
  },
  {
    path: routes.termsconditions,
    name: "terms-conditions",
    element: <TermsConditions />,
    route: Route,
  },
  {
    path: routes.privacypolicy,
    name: "privacy-policy",
    element: <PrivacyPolicy />,
    route: Route,
  },
  {
    path: routes.cookies,
    name: "cookies-policy",
    element: <CookiesPolicy />,
    route: Route,
  },
  {
    path: routes.gdpr,
    name: "gdpr",
    element: <GdprPolicy />,
    route: Route,
  },
  {
    path: routes.contact,
    name: "contact",
    element: <Contact />,
    route: Route,
  },
];

export const adminRoutes = [
  {
    path: routes.admin,
    name: "admin",
    element: <Admin />,
    route: Route,
  },
  {
    path: routes.addCar,
    name: "add-car",
    element: <AddCar />,
    route: Route,
  },
  {
    path: routes.editCar,
    name: "edit-car",
    element: <AddCar />,
    route: Route,
  },
];

